// Contact.jsx
import React, { useState } from "react";

export default function Contact() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [website, setWebsite] = useState(""); // honeypot
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setLoading(true);

    try {
      // jeśli honeypot ma wartość to nic nie wysyłamy
      if (website && website.trim() !== "") {
        setStatus({ ok: false, msg: "Spam detected" });
        setLoading(false);
        return;
      }

      const payload = { name: "Użytkownik", email, message, website };

      const res = await fetch("https://mm-easyaccess.com.pl/sendmail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const json = await res.json();

      if (res.ok && json.success) {
        setStatus({ ok: true, msg: json.message || "Wysłano wiadomość." });
        setEmail("");
        setMessage("");
        setWebsite("");
      } else {
        const err = json.error || (json.errors ? json.errors.join(", ") : "Błąd");
        setStatus({ ok: false, msg: err });
      }
    } catch (err) {
      console.error(err);
      setStatus({ ok: false, msg: "Błąd połączenia" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact container contact-split">
      <h3>KONTAKT</h3>

      <div className="contact-inner">
        <div className="contact-left">
          <div className="contact-row">
            <img className="icon" src={"images/call.png"} alt={"call"} />
            <span className="text">+48 516 903 322</span>
          </div>

          <div className="contact-row">
            <img className="icon" src={"images/message.png"} alt={"message"} />
            <span className="text">MM-EasyAccess@gmail.com</span>
          </div>

          <div className="contact-row">
            <img className="icon" src={"images/location.png"} alt={"lociation"} />
            <span className="text">Gdynia, Poland</span>
          </div>
        </div>

        <div className="contact-right">
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <textarea
              placeholder="Wiadomość"
              rows="6"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            ></textarea>

            {/* HONEYPOT: ukryte pole dla botów */}
            <input
              type="text"
              name="website"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
              // ukrywamy dla użytkownika - bots często je wypełniają
              style={{ display: "none" }}
              tabIndex="-1"
              autoComplete="off"
            />

            <button className="send-btn" type="submit" disabled={loading}>
              {loading ? "Wysyłanie..." : "WYŚLIJ"}
            </button>
          </form>

          {status && (
            <p style={{ marginTop: 10, color: status.ok ? "green" : "red" }}>
              {status.msg}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
